import React from 'react'; // eslint-disable-line
import classNames from 'classnames';

const createPosts = ({ posts }) => {
  if (!posts || posts.length < 1) return [];
  return posts.map((postData => <Post {...postData} />));
};

class Post extends React.Component {
  static createContentMarkup = htmlString => ({ __html: htmlString });

  state = {
    isExpanded: false,
  }

  handleReadMore = (e) => {
    e.preventDefault();
    this.setState({ isExpanded: true });
  }

  render() {
    return (
      <article
        className={classNames('intraPost', { '-long': !this.state.isExpanded && this.props.isLong })}
      >
        {this.props.thumbnail &&
          <figure
            className="intraPost__figure"
            style={`background-image: url(${this.props.thumbnail});`}
          />
        }
        <h2 className="intraPost__title">{this.props.title}</h2>
        <div className="intraPost__body">
          <div className="intraPost__details">
            <time className="intraPost__date">{this.props.date}</time>
            <span className="intraPost__author">{this.props.author.name}</span>
            <span className="intraPost__city">{this.props.author.city}</span>
          </div>
          <div
            className="intraPost__content"
            dangerouslySetInnerHTML={Post.createContentMarkup(this.props.content)}
          />
          {!this.state.isExpanded && this.props.isLong &&
            <button className="intraPost__readMore" onClick={this.handleReadMore}>
              <span>Läs mer</span>
            </button>
          }
        </div>
        <div className="intraPost__footer">
          <a href="#" className="intraPost__tag">Personalfrågor</a>
          <a href="#" className="intraPost__tag">Dolor sit amet</a>
        </div>
        <div className="intraPost__separator" />
      </article>
    );
  }
}

export default Post;
export {
  Post,
  createPosts,
};



// WEBPACK FOOTER //
// ./components/Intranet/News/Post.js